import { atom } from 'recoil'

export const isReorderingNodesAtom = atom<boolean>({
    key: 'isReorderingNodesAtom',
    default: false,
})
